import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Textarea from 'components/Textarea/Textarea';
import { RELEVANCE_TO_COMPANY } from 'constants/formFields';
import { DEFAULT_MAX_LIMITED } from 'constants/general';

import RowForm from './RowForm';
import RowLowForm from './RowLowForm';

import type IFormNGO from '../interfaces/IFormNGO';

import styles from '../scss/CreateNGO.module.scss';

function FormNGO({ control }: IFormNGO) {
  const { t } = useTranslation();
  return (
    <div className={styles.formWrapper}>
      <RowForm control={control} />
      <div className={styles.fullWidth}>
        <Controller
          control={control}
          name={RELEVANCE_TO_COMPANY}
          render={({ field: { name, value, onChange }, fieldState: { error } }) => (
            <Textarea
              name={name}
              value={value}
              label={t('materialityAssessment.fields.relevanceToCompany')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              placeholder={t('materialityAssessment.placeholder.typeHere')}
              charactersLimit={DEFAULT_MAX_LIMITED}
              required
            />
          )}
        />
      </div>
      <RowLowForm control={control} />
      <RowLowForm control={control} second />
    </div>
  );
}

export default FormNGO;
